export default __webpack_public_path__ + "static/media/Reduced Risk, Assured Compliance _ An Enhanced Customer Experience.429b66c8.png";